import { BlankSlate, Box, Spinner } from '@factorialco/deprecated-design-system'
import {
  AddExpensesExpensableCommentDocument,
  AddExpensesExpensableCommentMutation,
  ExpensableCommentsDocument,
  GetExpensablesDocument,
} from 'generated/resources/graphql'

import ErrorBoundary from 'modules/core/components/ErrorBoundary'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useMutation } from 'modules/core/hooks/useMutation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'

import { CommentsCommentValues } from 'modules/comments/components/CommentsContainer/CommentEditor'
import SidepanelComments from 'modules/comments/components/Wrappers/SidepanelComments'

interface Props {
  expensableId: number
}

const Comments = ({ expensableId }: Props) => {
  const { company } = useCurrentSession()

  const { data: commentsData, error } = useQuery(ExpensableCommentsDocument, {
    variables: { companyId: company.id, ids: [expensableId] },
  })

  const comments =
    commentsData?.expenses?.expensablesConnection?.nodes?.[0]?.commentsConnection?.nodes

  const [addComment] = useMutation(AddExpensesExpensableCommentDocument, {
    extractorFn: (data: AddExpensesExpensableCommentMutation) =>
      data.expensesMutations.createCommentExpensesExpensable,
  })

  const handleAddComment = (variables: CommentsCommentValues) => {
    return addComment({
      variables,
      refetchQueries: [GetExpensablesDocument],
      awaitRefetchQueries: true,
    })
  }

  return (
    <ErrorBoundary>
      {error ? (
        <Box alignItems="center" justifyContent="center" height="full">
          <BlankSlate
            illustration="alert"
            title={i18n.t('common.crash.title')}
            description={i18n.t('common.crash.retry')}
          />
        </Box>
      ) : !commentsData && !error ? (
        <Box alignItems="center" justifyContent="center" height="full" padding="s48">
          <Spinner />
        </Box>
      ) : (
        comments && (
          <SidepanelComments
            comments={comments}
            onAddComment={handleAddComment}
            resourceId={expensableId}
          />
        )
      )}
    </ErrorBoundary>
  )
}

export default Comments
